import React, {memo} from 'react';
import { array, string, func } from 'prop-types';
import classNames from 'classnames/bind';

import { ImageTechDoc } from 'components/ImageTechDoc';

import styles from './ProductImages.module.scss';
const cx = classNames.bind(styles);

const ProductImages = memo(({ data, alt, updateImage, activeImage }) => (
  <div className={cx('images-list')}>
    {data.map((item) => (
      <button
        key={item.thumbDocId}
        className={cx('small-thumnail', {
          active: item.thumbDocId === activeImage,
        })}
        onClick={() => updateImage(item.thumbDocId)}
      >
        <ImageTechDoc id={item.thumbDocId + '/1'} alt={alt} />
      </button>
    ))}
  </div>
));

ProductImages.propTypes = {
  data: array.isRequired,
  activeImage: string.isRequired,
  updateImage: func.isRequired,
  alt: string,
};

ProductImages.defaultProps = {
  alt: '',
};

export default ProductImages;



// WEBPACK FOOTER //
// ./src/pages/Product/components/ProductImages/ProductImages.js